/**
 * Presentation Layer - NextDayExportButton Component
 * 翌日データ出力ボタンコンポーネント
 */

import React from 'react';
import { Button, CircularProgress, Tooltip } from '@mui/material';
import { FileDownload as ExportIcon } from '@mui/icons-material';

/**
 * Props定義
 */
export interface NextDayExportButtonProps {
  /** クリック時のコールバック */
  onClick: () => void;
  /** ローディング中フラグ */
  isLoading?: boolean;
  /** 無効化フラグ */
  isDisabled?: boolean;
  /** 無効化理由（ツールチップで表示） */
  disabledReason?: string;
}

/**
 * 翌日データ出力ボタンコンポーネント
 */
export const NextDayExportButton: React.FC<NextDayExportButtonProps> = ({
  onClick,
  isLoading = false,
  isDisabled = false,
  disabledReason,
}) => {
  const button = (
    <Button
      variant="contained"
      color="secondary"
      onClick={onClick}
      disabled={isDisabled || isLoading}
      startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <ExportIcon />}
    >
      {isLoading ? '出力中...' : '翌日データ出力'}
    </Button>
  );

  // 無効化時にツールチップを表示
  if (isDisabled && disabledReason) {
    return (
      <Tooltip title={disabledReason} arrow>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};
